var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"remove-resource-btn",attrs:{"tabindex":"0"},on:{"mouseenter":_vm.toggleHover,"mouseleave":_vm.toggleHover,"click":_vm.removeResource,"keypress":_vm.removeResource}},[_c('i',{staticClass:"fa fa-lg fa-times",attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }